module.exports = __webpack_public_path__ + "img/DE01135.7b4f28ad.png";